module.exports = __webpack_public_path__ + "static/media/transfer-icon-white.d886536b.svg";